// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"d3d021c0","239":"72ffcaed","455":"eac576a9"}[chunkId] + ".chunk.js";
};